<template>
    <div>
        <input
            class="input"
            :class="{ 'is-danger' : errors.has(formName) }"
            :name="formName"
            v-model="localValue.value"
            v-validate="'required|decimal'"
            @keypress.enter="$emit('enter')"
        />
        <div
            class="error-message"
            v-show="errors.has(formName)"
        >
            You must enter a valid number
        </div>
    </div>
</template>

<script>
export default {
    name : "Number",
    inject : ['$validator'],
    props : {
        value : {
        },
        formName : {
            type : String,
            required : true,
        },
    },
    computed : {
        localValue : {
            get () { return this.value },
            set () { this.$emit('input', this.localValue )}
        }
    },
}
</script>

<style scoped>

</style>
